import UsersProfileContainer from "../../../../Component/Application/Users/UsersProfile/UsersProfile"

const UsersProfile = () => {
  return (
    <div className='page-body'>
      <UsersProfileContainer />
    </div>
  )
}

export default UsersProfile